export const MISSING_REFRESH_TOKEN_MESSAGE = 'Missing refresh token';
export const MISSING_ACCESS_TOKEN_MESSAGE = 'Missing access token';

export const AWS_SIGV4_INTERCEPTOR_REGION = 'us-east-1';
export const AWS_SIGV4_INTERCEPTOR_SERVICE = 'auth';
